import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/v1/employees', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/employees', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, options = {}) => {
  return httpClient
    .get(`/api/v1/employees/${id}`, options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/employees/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/employees/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const photoUpload = data => {
  return httpClient
    .post('/api/v1/employees/photos', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const position = (options = {}) => {
  return httpClient
    .get('/api/v1/employees/logic-positions', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const status = (options = {}) => {
  return httpClient
    .get('/api/v1/employees/status', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const statusReason = (options = {}) => {
  return httpClient
    .get('/api/v1/employees/status-reason', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const shift = (Option = {}) => {
  return httpClient
    .get('/api/v1/employees/shifts', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const pcDate = (Option = {}) => {
  return httpClient
    .get('/api/v1/employees/pc-date', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const paymentType = (Option = {}) => {
  return httpClient
    .get('/api/v1/employees/payment-types', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const nationality = (Option = {}) => {
  return httpClient
    .get('/api/v1/employees/nationalities', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  find,
  update,
  destroy,
  photoUpload,
  position,
  status,
  statusReason,
  shift,
  pcDate,
  paymentType,
  nationality
}
